module.exports = __webpack_public_path__ + "img/roadtrip.ba35ce15.jpg";